import React, { /* useEffect */ useState, useRef } from "react";
import { Dialog, DialogContent, DialogActions, DialogTitle, TextField, InputAdornment, Button, IconButton, Alert, AlertTitle, Box, FormHelperText, Paper, Grid } from "@mui/material";
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';
/* REQUEST */
import { createCategory } from 'utils/Category'

const PaperComponent = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const AddCategory = ({ open, setOpen, rows, setAlert, setOpenAlert, reloading }) => {
    const {t} = useTranslation()
    const [name, setName] = useState('')
    const [nameLength, setNameLength] = useState(0)
    const [alerts, setAlerts] = useState(false)
    const [loading, setLoading] = useState(false)

    const existName = (name) => {
        let exist = false
        rows.forEach((row) => {
            if (String(row.name).toLocaleLowerCase() === String(name).toLocaleLowerCase()) {
                exist = true
            }
        })
        return exist
    }

    const closeForm = () => {
        setOpen(false)
        setName('')
        setNameLength(0)
    }

    const changes = () => {
        return name !== '' ? setAlerts(true) : closeForm()
    }

    const disabled = () => {
        return name === '' || existName(name)
    }

    const addCategory = async () => {
        setLoading(true)
        try {
            const response = await createCategory(name)
            if (response.length > 0) {
                setAlert({
                    msg: t('custom_reports.category.table.dialog.add.messages.success'),
                    severity: 'success'
                })
                setOpenAlert(true)
                setLoading(false)
                closeForm()
                reloading()
            }
        } catch (error) {
            console.error(error)
            setAlert({
                msg: t('custom_reports.category.table.dialog.add.messages.error'),
                severity: 'error'
            })
            setOpenAlert(true)
            setLoading(false)
        }
    }
    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            PaperComponent={PaperComponent}
            onClose={(event, reason) =>{
                if(reason !== 'backdropClick') {
                    return;
                }
                changes()
            }}
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{t('custom_reports.category.table.dialog.add.title')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => changes()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box sx={{ top : 0, zIndex: 10, pb: 1}}>
                {
                    alerts &&
                        <Alert
                            variant='filled'
                            severity="warning"
                            sx={{ mt: 2 }}
                            action={
                                <>
                                    <Button onClick={() => closeForm()} color="inherit" size="small" variant='text' disableElevation>
                                        {t('custom_reports.category.table.dialog.add.alert.unsaved_changes.buttons.yes')}
                                    </Button>
                                    <Button onClick={() => setAlerts(false)} color='inherit' size='small' variant='text' disableElevation>
                                        {t('custom_reports.category.table.dialog.add.alert.unsaved_changes.buttons.no')}
                                    </Button>
                                </>
                            }
                        >
                            <AlertTitle>{t('custom_reports.category.table.dialog.add.alert.unsaved_changes.message')}</AlertTitle>
                        </Alert>
                }
            </Box>
        <DialogContent dividers>
            <Grid container>
                <Grid size={{ xs: 10, sm: 12, md: 12, lg: 12 }}>
                    <TextField
                        id={'input-name'}
                        fullWidth
                        label={t('custom_reports.category.table.dialog.add.name')}
                        value={name}
                        autoComplete="off"
                        onChange={(e) => {
                            setName(e.target.value)
                            setNameLength(e.target.value.length)
                            existName(e.target.value)
                        }}
                        placeholder={t('custom_reports.category.table.dialog.add.max_name')}
                        required
                        error={existName(name)}
                        slotProps={{
                            htmlInput: { maxLength: 100 },
                            input: {
                                endAdornment: <InputAdornment position="end">{`${nameLength}/100`}</InputAdornment>,
                            },
                        }}
                    />
                    <FormHelperText
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            mt: 0.5,
                            px: 1.75
                        }}
                    >
                        <span>{existName(name) ? t('custom_reports.category.table.dialog.add.exist_name') : ''}</span>
                        {/* <span></span> */}
                    </FormHelperText>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="error" onClick={() => changes()}>{t('custom_reports.category.table.dialog.add.buttons.cancel')}</Button>
            <Button variant="contained" color="primary" loading={loading} disabled={disabled()} onClick={() => addCategory()}>{t('custom_reports.category.table.dialog.add.buttons.add')}</Button>
        </DialogActions>
        </Dialog>
    )
}

export { AddCategory };